import { Injectable, computed, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FeedbackVisibilityService {
  private readonly hiddenSources = new Set<string>();
  private readonly hiddenCount = signal(0);

  readonly isHidden = computed(() => this.hiddenCount() > 0);

  setHidden(source: string, hidden: boolean): void {
    const normalizedSource = source.trim();

    if (!normalizedSource) {
      return;
    }

    const before = this.hiddenSources.size;

    if (hidden) {
      this.hiddenSources.add(normalizedSource);
    } else {
      this.hiddenSources.delete(normalizedSource);
    }

    if (this.hiddenSources.size !== before) {
      this.hiddenCount.set(this.hiddenSources.size);
    }
  }

  clear(source: string): void {
    this.setHidden(source, false);
  }
}
